<!--
  物流
-->
<template>
  <div class="logistics-box">
    <title-header title="查看物流"></title-header>
    <div class="goods-info-box">
      <div v-for="(item,index) in goodsInfo" :key="index" class="goods-item">
        <img v-bind:src="item.picUrl" class="goods-image" alt="">
        <div class="goods-info">
          <div class="over2line">{{item.goodsName}}</div>
          <div>共{{item.num}}件</div>
        </div>
      </div>
    </div>
    <div class="logistics-header">
      <div>
        <span class="label">物流公司： </span>
        <span>{{logisticsBaseInfo.name}}</span>
      </div>
      <div>
        <span class="label">运单号码： </span>
        <span>{{logisticsBaseInfo.shippingNo}}</span>
      </div>
    </div>
    <van-steps direction="vertical" active-color="#45C5DA" :active="0">
      <van-step v-for="(item,index) in logistics" :key=index>
        <div slot="active-icon">
          <van-icon name="checked" color="#45C5DA" size="20" />
        </div>
        <div class="logistics-info" :class="{'active-item': index === 0}">
          <div class="info">{{item.AcceptStation}}</div>
          <p class="time">{{item.AcceptTime}}</p>
        </div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
  import api from 'api/user';
  export default {
    data() {
      return {
        shipperCode: '',
        logisticCode: '',
        logistics: [], //物流信息
        goodsInfo: [], //商品信息
        logisticsBaseInfo: {}, //物流公司
      }
    },
    created() {
      this.orderSn = this.$route.query.orderSn;
      this.getLogisticsInfo()
    },
    methods: {
      async getLogisticsInfo() {
        const params = {
          orderSn: this.orderSn
        }
        const data = await api.getLogistics(params);
        this.logisticsBaseInfo = data;
        this.logistics = data.shippingInfo.Traces;
        this.goodsInfo = data.orderGoods.records;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'common/sass/theme.scss';
  .logistics-box{
    .goods-info-box{
      border-bottom: 10px solid #eee;
      .goods-item{
        display: flex;
        padding: 10px;
        .goods-image{
          display: inline-block;
          width: 60px;
          height: 60px;
          margin-right: 10px;
        }
        .goods-info{
          flex: 1;
          font-size: 14px;
        }
      }
    }
    .logistics-header{
      padding: 10px;
      font-size: 14px;
      border-bottom: 10px solid #eee;
      .label{
        color: #999;
      }
    }
    .logistics-info{
      .info{
        font-size: 14px;
        color: #333;
      }
      .time{
        font-size: 12px;
        color: #999;
      }
    }
    .active-item{
      .info,.time{
        color: $theme-color !important;
      }
    }
  }
</style>